export const properties = {
    apiUrl: process.env.REACT_APP_HOST,
    company: 'Company',
    showAll: true,
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    permissions: "Permissions",
    location: 'Location',
    position: 'Position',
    permission_admin:'System Administrator from Operator',
    permission_regular: 'Regular User',
    permission_operator: 'Nominated Contact Person',
    permission_read: 'Read Only',
    permission_internal : "Internal user",
    permission_super: 'Super Administrator',
    previewRowsPerPage: 10
};

const variantsStr = process.env.REACT_APP_KEYCLOAK_INSTANCES || "";


export const PROVIDERS = variantsStr
    .split(',')
    .map(v => v.trim())
    .map(variant => {
        const V = variant.toUpperCase();
        return {
            id: variant,
            name: process.env[`REACT_APP_KEYCLOAK_${V}_NAME`],
            label: process.env[`REACT_APP_KEYCLOAK_${V}_LABEL`] || variant,
            url: process.env[`REACT_APP_KEYCLOAK_${V}_URL`],
            realm: process.env[`REACT_APP_KEYCLOAK_${V}_REALM`],
            clientId: process.env[`REACT_APP_KEYCLOAK_${V}_CLIENT_ID`],
            apiClientId: process.env[`REACT_APP_KEYCLOAK_${V}_API_CLIENT_ID`] || 'inventory-api'
        };
    });
